import { Button, Loading } from '../../../../components';

import { Modal as ModalAnt } from 'antd';

import ModalHeader from '../../../../components/generic/ModalHeader';
import { useEffect } from 'react';
import FetchError from '../../../../components/generic/FetchError';
import { ApolloError } from '@apollo/client';
import InputField from '../../../../components/generic/InputField/InputField';
import { useForm } from 'react-hook-form';

type CreateOrEditMaterialProps = {
  activeMaterial: any;
  isMaterialModalOpen: boolean;
  handleCloseEditMaterialModal: () => void;
  onFinish: (values: any) => void;
  isLoading: boolean;
  error: ApolloError | undefined;
};

const CreateOrEditMaterial = ({
  activeMaterial,
  isMaterialModalOpen,
  handleCloseEditMaterialModal,
  onFinish,
  isLoading,
  error,
}: CreateOrEditMaterialProps) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const defaultValues = { material: activeMaterial?.name || '' };
    reset(defaultValues);
  }, [isMaterialModalOpen, activeMaterial, reset]);

  return (
    <ModalAnt
      title={
        <ModalHeader
          title={activeMaterial ? 'EDIT MATERIAL' : 'ADD MATERIAL'}
        />
      }
      open={isMaterialModalOpen}
      onCancel={handleCloseEditMaterialModal}
      footer={null}
      className="custom-modal"
      centered
    >
      {!isLoading ? (
        <form className="max-w-100 mx-auto" onSubmit={handleSubmit(onFinish)}>
          <InputField
            type="text"
            label="Name / Type"
            name="material"
            rules={{ required: true }}
            errors={errors.material}
            control={control}
            errorMessage="This field is required"
            register={register}
            spaceBetween
          />
          <div className="mt-6 flex justify-end">
            <Button type={'default'} htmlType={'submit'} className="py-1">
              Save
            </Button>
          </div>
          {error && <FetchError error={error.message} />}
        </form>
      ) : (
        <Loading />
      )}
    </ModalAnt>
  );
};

export default CreateOrEditMaterial;
